import { Component, inject, Input } from '@angular/core';
import { MessageMaintenance } from '../../models/message-maintenance';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiAppearance, TuiButton, tuiDialog } from '@taiga-ui/core';
import { MessageMaintenanceModalComponent } from '../message-maintenance-modal/message-maintenance-modal.component';
import { Subscription, timer } from 'rxjs';
import { MessageMaintenanceService } from '../../services/message-maintenance.service';

@Component({
  selector: 'app-message-maintenance-row',
  standalone: true,
  imports: [
    TuiTable,
    TuiButton,
    TuiAppearance
  ],
  templateUrl: './message-maintenance-row.component.html',
  styleUrl: './message-maintenance-row.component.scss',
})
export class MessageMaintenanceRowComponent {
  @Input()
  public messageMaintenance?: MessageMaintenance;

  @Input({ required: true })
  public refreshList!: () => void;

  private modal: Subscription | undefined;


  private readonly dapMessageMaintenanceModal = tuiDialog(MessageMaintenanceModalComponent);
  private readonly messageMaintenanceService = inject(MessageMaintenanceService);

  openDialog(): void {
    this.modal = this.dapMessageMaintenanceModal({ messageMaintenance: this.messageMaintenance, onClose: () => this.closeDialog(), refreshList: () => this.refreshList() }).subscribe();
  }

  closeDialog(): void {
    this.modal?.unsubscribe();
  }

  destroy(): void {
    if (this.messageMaintenance !== undefined)
      this.messageMaintenanceService.destroy(this.messageMaintenance.id).subscribe({
        next: () => {
          this.refreshList();
        },
      });
  }
}
